module.exports = __webpack_public_path__ + "img/BRCA4_Mono.Macro.23ccfe0e.png";